"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _helpers = require("@/helpers");
var _components = require("@/components");
var _validators = require("vuelidate/lib/validators");
var _vuex = require("vuex");
var _validate = require("@/utils/validate");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var validCPF = function validCPF(value) {
  return (0, _validate.validateCPF)(value);
};
var validCNPJ = function validCNPJ(value) {
  return (0, _validate.validateCNPJ)(value);
};
var _default2 = exports.default = {
  components: {
    Card: _components.Card,
    AppInput: _components.AppInput,
    AppSelect: _components.AppSelect
  },
  props: {
    next: {
      type: Function,
      required: true
    },
    clientForm: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      idClient: null,
      channelSave: null,
      listTypes: [{
        id: 1,
        name: 'Pessoa Jurídica'
      }],
      fileLogo: null,
      listLanguages: [{
        id: 'portugues',
        name: 'Português'
      }, {
        id: 'ingles',
        name: 'Inglês'
      }, {
        id: 'espanhol',
        name: 'Espanhol'
      }],
      listAPIValidDocument: [{
        id: 'identity',
        name: 'Identity'
      }, {
        id: 'serasa',
        name: 'Serasa'
      }],
      listCountries: [{
        id: 'ARGENTINA',
        name: 'Argentina'
      }, {
        id: 'BRASIL',
        name: 'Brasil'
      }, {
        id: 'EUA',
        name: 'EUA'
      }],
      form: {
        organizationType: 1,
        businessName: '',
        name: '',
        document: '',
        email: '',
        phone: '',
        zipCode: '',
        address: '',
        addressNumber: '',
        District: '',
        city: '',
        state: '',
        secretId: '',
        clientId: '',
        description: '',
        logo: '',
        contactName: '',
        contactCpf: '',
        contactEmail: '',
        site: '',
        setor: '',
        size: '',
        language: '',
        country: '',
        componentValidDocument: ''
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['registrationForm'])), {}, {
    labelNameClient: function labelNameClient() {
      if (this.isPJ) return 'Razão social';
      return 'Nome do cliente';
    },
    placeNameClient: function placeNameClient() {
      if (this.isPJ) return 'Informe a nome razão social';
      return 'Informe o nome do cliente';
    },
    isPF: function isPF() {
      return this.form.organizationType && this.form.organizationType === 2;
    },
    isPJ: function isPJ() {
      return this.form.organizationType && this.form.organizationType === 1;
    },
    logoValid: function logoValid() {
      if ((0, _validate.validURL)(this.form.logo)) return true;
      return false;
    },
    isBlocked: function isBlocked() {
      return this.idClient !== null;
    }
  }),
  watch: {
    fileLogo: function () {
      var _fileLogo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(val) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(val && val.type)) {
                _context.n = 1;
                break;
              }
              if (!(val.type.indexOf('image/') < 0)) {
                _context.n = 1;
                break;
              }
              return _context.a(2, _helpers.messageHelper.error('Somente arquivos de imagens são aceitos'));
            case 1:
              this.form.logo = val;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function fileLogo(_x) {
        return _fileLogo.apply(this, arguments);
      }
      return fileLogo;
    }()
  },
  validations: function validations() {
    if (this.isPF) {
      return {
        form: {
          organizationType: {
            required: _validators.required
          },
          businessName: {
            required: _validators.required,
            minLength: (0, _validators.minLength)(4)
          },
          document: {
            required: _validators.required,
            validCPF: validCPF
          },
          email: {
            required: _validators.required,
            email: _validators.email
          },
          phone: {
            required: _validators.required
          },
          zipCode: {},
          address: {},
          addressNumber: {},
          district: {},
          city: {},
          state: {},
          SecretId: {},
          ClientId: {},
          description: {},
          logo: {},
          site: {},
          setor: {},
          size: {}
        }
      };
    }
    return {
      form: {
        organizationType: {
          required: _validators.required
        },
        businessName: {
          required: _validators.required,
          minLength: (0, _validators.minLength)(4)
        },
        name: {},
        document: {
          required: _validators.required,
          validCNPJ: validCNPJ
        },
        email: {
          email: _validators.email
        },
        phone: {},
        zipCode: {
          required: _validators.required
        },
        address: {},
        addressNumber: {},
        district: {},
        city: {},
        state: {},
        SecretId: {},
        clientId: {},
        description: {},
        logo: {},
        contactName: {},
        contactCpf: {},
        contactEmail: {},
        site: {},
        setor: {},
        size: {},
        language: {},
        country: {},
        componentValidDocument: {}
      }
    };
  },
  created: function created() {
    var id = this.$route.params.id;
    if (id) {
      this.idClient = id;
      this.joinForms();
    }
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['fetchZip', 'createClient', 'updateClient', 'fetchClient', 'uploadToS3'])), {}, {
    checkForm: function checkForm() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Por favor, verifique os campos <b>obrigat\xF3rios</b>!",
          position: 'is-top',
          type: 'is-danger'
        });
        return false;
      }
      return true;
    },
    saveClient: function () {
      var _saveClient = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
        var valid, payload, operation, message, urlFileImage, dataClient;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.checkForm(this.createUser);
            case 1:
              valid = _context2.v;
              if (!valid) {
                _context2.n = 5;
                break;
              }
              payload = {
                organizationType: 1,
                businessName: this.form.businessName,
                name: this.form.name,
                document: this.form.document,
                email: this.form.email,
                phone: this.form.phone,
                zipCode: this.form.zipCode,
                address: this.form.address,
                addressNumber: this.form.addressNumber,
                district: this.form.district,
                city: this.form.city,
                state: this.form.state,
                secretId: this.form.secretId,
                clientId: this.form.clientId,
                description: this.form.description,
                logo: this.form.logo,
                site: this.form.site,
                setor: this.form.setor,
                size: Number(this.form.size),
                country: this.form.country,
                language: this.form.language,
                componentValidDocument: this.form.componentValidDocument
              };
              operation = this.createClient;
              message = 'Cliente cadastrado com sucesso!'; // TODO: Implementar atualização do cliente
              if (this.idClient) {
                operation = this.updateClient;
                message = 'Cliente alterado com sucesso!';
                payload.idClient = this.idClient;
              }

              // TODO: Implementar registro de logo
              if (!this.fileLogo) {
                _context2.n = 3;
                break;
              }
              _context2.n = 2;
              return this.uploadFiles(this.fileLogo, 'png');
            case 2:
              urlFileImage = _context2.v;
              if (urlFileImage) payload.logo = urlFileImage;
            case 3:
              _context2.n = 4;
              return operation(payload);
            case 4:
              dataClient = _context2.v;
              if (dataClient) {
                this.$buefy.toast.open({
                  message: message,
                  type: 'is-success',
                  duration: 5000
                });
                this.$router.push({
                  name: 'ClientsList'
                });
              }
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function saveClient(_x2) {
        return _saveClient.apply(this, arguments);
      }
      return saveClient;
    }(),
    consultzipcode: function () {
      var _consultzipcode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(e) {
        var cep, data;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              cep = e.target.value || '';
              if (!(cep.length < 10)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, this.$message({
                message: 'Por favor, verifique se o CEP está correto.',
                type: 'warning'
              }));
            case 1:
              _context3.n = 2;
              return this.fetchZip(cep);
            case 2:
              data = _context3.v;
              if (data) {
                this.$v.form.address.$model = data.logradouro;
                this.$v.form.city.$model = data.localidade;
                this.$v.form.state.$model = data.uf;
                this.$v.form.district.$model = data.bairro;
              }
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function consultzipcode(_x3) {
        return _consultzipcode.apply(this, arguments);
      }
      return consultzipcode;
    }(),
    joinForms: function joinForms() {
      for (var _i = 0, _Object$entries = Object.entries(this.clientForm); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 1),
          key = _Object$entries$_i[0];
        this.form[key] = this.clientForm ? this.clientForm[key] || null : null;
      }
    },
    uploadFiles: function () {
      var _uploadFiles = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(file, type) {
        var self;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              self = this;
              return _context5.a(2, new Promise(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(resolve, reject) {
                  var data, resp;
                  return _regenerator().w(function (_context4) {
                    while (1) switch (_context4.n) {
                      case 0:
                        data = {
                          image: file,
                          typeFile: type || ''
                        };
                        _context4.n = 1;
                        return self.uploadToS3(data);
                      case 1:
                        resp = _context4.v;
                        if (resp) resolve(resp);else reject();
                      case 2:
                        return _context4.a(2);
                    }
                  }, _callee4);
                }));
                return function (_x6, _x7) {
                  return _ref.apply(this, arguments);
                };
              }()));
          }
        }, _callee5, this);
      }));
      function uploadFiles(_x4, _x5) {
        return _uploadFiles.apply(this, arguments);
      }
      return uploadFiles;
    }()
  })
};